import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function Copyright() {
  return (
    <Container>
        <Row className='align-items-center'>
            <Col md={12}>
                <p className='text-center text-white'>Copyright © 2023. Click Circle. Allright reserved.</p>
            </Col>
        </Row>
    </Container>
  )
}

export default Copyright